module.exports = __webpack_public_path__ + "media/images/spinner-245-1d0cf13bd3119851369f185a3366879f.gif";